import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Spin } from 'antd';
import { privatePagesList } from '../../constants/pages.js';
import MonthYearSelector from '../monthYearSelector/MonthYearSelector';
import EditProjection from '../editProjection/EditProjection';
import ProjectionDisplay from '../projectionDisplay/ProjectionDisplay';

import './FormWrapper.scss';

const currentDate = new Date();

const FormWrapper = ({ slug, type }) => {
  const [currentPage, setCurrentPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentDate.getFullYear(),
  });
  const [projectionValue, setProjectionValue] = useState('');
  const [total, setTotal] = useState(null);

  const handleDateChange = ({ month, year }) => {
    setSelectedDate({ month, year });
  };

  useEffect(() => {
    const item = Object.values(privatePagesList).find((v) => v.slug === slug);
    setCurrentPage(item);
  }, [slug]);

  return (
    <div className="FormWrapper">
      <Spin tip="Carregando" spinning={loading}>
        <Card style={{ width: '100%' }}>
          <Row justify="space-between" align="middle">
            <Col span={12} style={{ textAlign: 'center' }}>
              <MonthYearSelector onChange={handleDateChange} />
            </Col>
            <Col span={12} style={{ textAlign: 'center' }}>
              {type != 'PANEL' &&
                <EditProjection
                  month={selectedDate.month}
                  year={selectedDate.year}
                  type={type}
                  projectionValue={projectionValue}
                  setProjectionValue={setProjectionValue}
                />
              }
            </Col>
          </Row>
        </Card>

        <ProjectionDisplay total={total} projectionValue={projectionValue} name={currentPage?.pageTitle} />

        {currentPage?.component && (
          <currentPage.component
            month={selectedDate.month}
            year={selectedDate.year}
            total={total}
            setTotal={setTotal}
            setProjectionValue={setProjectionValue}
          />
        )}

      </Spin>
    </div>
  );
};

export default FormWrapper;
